import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import LoadingPlaceholder from 'components/loadingPlaceholder';
import usePlacesProvider from 'dataProvider/hooks/usePlacesProvider';
import useDebounce from 'dataProvider/hooks/useDebounce';
import { TYPES } from 'envs';
import {
  useRESTDataCache,
  getChilds,
  nearestTownRest
} from '../../dataProvider';
import Autocomplete from '../../components/autocomplete';
import { PROPERTIES_JSON, excludedGrandParentIds } from '../../core/constants';
import { getSite } from '../../constants/sites';

const MODES = {
  MANUAL: 'manual',
  CERCANOS: 'cercanos',
  HIJOS: 'hijos'
};

const CopyBox = ({ buttonText, children, className }) => {
  const elementRef = useRef();
  return (
    <div className={className}>
      <pre className="border scroll" ref={elementRef}>
        {children}
      </pre>
      <button
        type="button"
        className="button  fixed-btn"
        onClick={() => {
          const range = document.createRange();
          range.selectNodeContents(elementRef.current);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          document.execCommand('copy');
          sel.removeRange(range);
        }}
      >
        {buttonText}
      </button>
    </div>
  );
};

CopyBox.propTypes = {
  buttonText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired
};

const ButtonGenerator = ({
  electionType,
  currentPlace,
  year,
  electionNumber
}) => {
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  const [mode, setMode] = useState(MODES.MANUAL);
  const [places, setPlaces] = useState([]);

  useEffect(() => {
    // Set initial selected places
    switch (mode) {
      default:
      case MODES.MANUAL: {
        setPlaces([]);
        break;
      }
      case MODES.CERCANOS: {
        if (currentPlace.location) {
          nearestTownRest(
            currentPlace.ineId,
            currentPlace.location.lat,
            currentPlace.location.lon,
            electionType
          ).then(response => {
            const placesResponse = response.content || [];
            setPlaces(
              placesResponse.filter(
                place => place.grandpaId === currentPlace.grandpaId
              )
            );
          });
        } else {
          setPlaces([]);
        }
        break;
      }
      case MODES.HIJOS: {
        getChilds(
          currentPlace.typePlace === 'REGION' ? 'PROVINCE' : 'TOWN',
          currentPlace.ineId,
          electionType
        ).then((data = {}) => setPlaces(data.content || []));
        break;
      }
    }
  }, [electionType, electionNumber, year, currentPlace, mode]);

  const addPlace = place => {
    if (!places.find(p => p.ineId === place.ineId)) {
      setPlaces([...places, place]);
    }
  };

  const removePlace = place => {
    // setAutocomplete('');
    setPlaces(places.filter(item => item.ineId !== place.ineId));
  };
  const site = getSite();

  const [autocompleMun, setAutocompleMun] = useState('');
  const { result: dataPlacesProvince } = usePlacesProvider({
    type: 'PROVINCE',
    sortby: 'name',
    excludedGrandParentIds:
      electionType === TYPES.REGIONAL ? excludedGrandParentIds : [],
    electionType
  });
  const { result: dataPlacesRegion } = usePlacesProvider({
    type: 'REGION',
    sortby: 'name',
    excludedGrandParentIds,
    electionType
  });
  const debouncedSearch = useDebounce(autocompleMun, 400);
  const { result: dataPlacesTown } = usePlacesProvider({
    sortby: 'name',
    name: debouncedSearch,
    type: 'TOWN',
    // grandParentId: province ? null : community,
    size: 10,
    excludedGrandParentIds:
      electionType === TYPES.REGIONAL ? excludedGrandParentIds : [],
    electionType
  });
  if (!params || !dataPlacesRegion || !dataPlacesProvince || !dataPlacesTown) {
    return <LoadingPlaceholder />;
  }

  return (
    <div className="containerel">
      <div className="flex-container ">
        <div className="flex-row center">
          <button
            type="button"
            className={`button-gen ${mode === MODES.MANUAL && 'selected'}`}
            onClick={() => setMode(MODES.MANUAL)}
          >
            Manual
          </button>
          {currentPlace && currentPlace.typePlace === 'TOWN' ? (
            <button
              type="button"
              className={`button-gen ${mode === MODES.CERCANOS && 'selected'}`}
              onClick={() => setMode(MODES.CERCANOS)}
            >
              Cercanos
            </button>
          ) : (
            <button
              type="button"
              className={`button-gen ${mode === MODES.HIJOS && 'selected'}`}
              onClick={() => setMode(MODES.HIJOS)}
            >
              Hijos
            </button>
          )}
        </div>
        {mode === MODES.MANUAL && (
          <div className="flex-row center">
            {electionType !== 'MUNICIPAL' && (
              <div className="m10 w200">
                <Autocomplete
                  results={dataPlacesRegion}
                  onSelect={(e, select) => {
                    e.preventDefault();
                    addPlace(select);
                  }}
                  placeholder="Buscar comunidad"
                  showArrow
                  defaultValue={dataPlacesRegion.length > 0}
                  type={electionType}
                  params={params}
                  year={year}
                />
              </div>
            )}

            <div className="m10 w200">
              <Autocomplete
                results={dataPlacesProvince}
                onSelect={(e, select) => {
                  e.preventDefault();
                  addPlace(select);
                }}
                placeholder="Buscar provincia"
                showArrow
                defaultValue={dataPlacesProvince.length > 0}
                type={electionType}
                params={params}
                year={year}
              />
            </div>
            <div className="m10 w200">
              <Autocomplete
                results={dataPlacesTown}
                onChange={value => setAutocompleMun(value)}
                onSelect={(e, select) => {
                  e.preventDefault();
                  addPlace(select);
                }}
                placeholder="Buscar municipio"
                showArrow
                type={electionType}
                params={params}
                year={year}
              />
            </div>
          </div>
        )}

        <div className="row">
          <div className="w20 mh left list">
            <ol className="border">
              {places.map(place => (
                <li key={place.ineId}>
                  <p>
                    <button
                      type="button"
                      className="button"
                      onClick={() => removePlace(place)}
                    >
                      X
                    </button>
                    {place.name}
                  </p>
                </li>
              ))}
            </ol>
          </div>
          <CopyBox className="w20 mh left" buttonText="Copiar">
            {
              '<div class="related-tags mod-tags"><ul class="listado-categorias tags-list tags">'
            }
            {places.map(place =>
              site === 'antena3'
                ? `<li class="article-tags-list__item elections"><a class="tags-list__link btn btn-primary" title="${place.name}" href="${place.path}"                   target="_parent" > ${place.name} </a></li>`
                : `<li><a class="tags-list__link btn btn-secondary" title="${place.name}" href="${place.path}"                   target="_parent" > ${place.name} </a></li>
                `
            )}
            {'</ul></div>'}
          </CopyBox>
          <CopyBox className="w20 mh left" buttonText="Copiar AMP">
            {
              '<div class="related-tags mod-tags"><ul class="listado-categorias tags-list tags">'
            }
            {places.map(place =>
              site === 'antena3'
                ? `<li class="article-tags-list__item elections"><a class="tags-list__link btn btn-primary" title="${place.name}" href="${place.path}"                   target="_parent" > ${place.name} </a></li>`
                : `<li><a class="tags-list__link btn btn-secondary" title="${place.name}" href="${place.path}"                   target="_parent" > ${place.name} </a></li>`
            )}
            {'</ul></div>'}
          </CopyBox>
          <div className="w40 mh left border">
            {places.map(place => (
              <a
                key={place.ineId}
                href={place.path}
                type="button"
                className="tag"
              >
                {place.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ButtonGenerator;

ButtonGenerator.propTypes = {
  electionType: PropTypes.string.isRequired,
  currentPlace: PropTypes.shape({
    typePlace: PropTypes.string.isRequired,
    grandpaId: PropTypes.string.isRequired,
    ineId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    location: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lon: PropTypes.number.isRequired
    })
  }).isRequired,
  year: PropTypes.string.isRequired,
  electionNumber: PropTypes.string.isRequired
};
